import { AnyAction } from 'redux';
import { RESET_STATE, MODAL_SWITCH, MODAL_SAVE_FORM, MODAL_LOADER_BTN, MODAL_CONFIRM_DATA, CONFIRM_MODAL_SWITCH } from '@app/store/constants';

const initialModalSwitchState = {
    modalSwitcher: false,
    confirmModalSwitcher: false,
    modalSaveForm: [],
    modalConfirmData: [],
    modalLoaderBtn: false
};

export function modal(state = initialModalSwitchState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_STATE:
            return initialModalSwitchState;
        case MODAL_SWITCH:
            return {
                ...state,
                modalSwitcher: payload
            };
        case CONFIRM_MODAL_SWITCH:
            return {
                ...state,
                confirmModalSwitcher: payload
            };
        case MODAL_SAVE_FORM:
            return {
                ...state,
                modalSaveForm: payload
            };
        case MODAL_CONFIRM_DATA:
                return {
                    ...state,
                    modalConfirmData: payload
                };
        case MODAL_LOADER_BTN:
            return {
                ...state,
                modalLoaderBtn: payload
            };
        default:
            return state;
    }
}
